import { computed, Directive, input } from '@angular/core';

export type TxtVariant =
  | 'body-base'
  | 'body-large'
  | 'body-small'
  | 'body-x-small'
  | 'display-regular-large'
  | 'display-regular-medium'
  | 'display-regular-small'
  | 'display-semibold-large'
  | 'display-semibold-medium'
  | 'display-semibold-small'
  | 'heading-h1'
  | 'heading-h2'
  | 'heading-h3'
  | 'heading-h4'
  | 'heading-h5'
  | 'heading-h6'
  | 'labels-base'
  | 'labels-large'
  | 'labels-small'
  | 'labels-x-small'
  | 'subheader-large'
  | 'subheader-medium'
  | 'subheader-x-large'
  | 'subheader-xx-large'
  | 'subheader-xxx-large';

const TXT_COLORS = {
  'on-surface': '--foreground-neutral-on-surface',
  'on-surface-variant-01': '--foreground-neutral-on-surface-variant-01',
  'on-surface-variant-02': '--foreground-neutral-on-surface-variant-02',
  'on-surface-variant-03': '--foreground-neutral-on-surface-variant-03',
  green: '--data-visual-green',
};

type TextColor = keyof typeof TXT_COLORS;

@Directive({
  selector: '[bspk-txt]',
  host: {
    '[attr.data-txt]': 'variant()',
    '[style.font]': 'font()',
    '[style.color]': 'fontColorValue()',
  },
})
export class BspkTxt {
  readonly variant = input<TxtVariant | ''>('body-base', { alias: 'bspk-txt' });
  readonly font = computed(() => `var(--${this.variant() || 'body-base'})`);
  readonly color = input<TextColor>();

  protected readonly fontColorValue = computed(() => {
    const color = this.color();
    if (color) {
      return `var(${TXT_COLORS[color]})`;
    }
    return null;
  });
}
